import type { Asset } from "./types";

export type AssetVariantGroup = {
  asset: Asset;
  variants: Asset[];
};

export function groupAssetsByVariant(assets: Asset[]): AssetVariantGroup[] {
  const assetById = new Map(assets.map((asset) => [asset.id, asset]));
  const variantsByParent = new Map<string, Asset[]>();
  const groupedVariantIds = new Set<string>();

  for (const asset of assets) {
    const parentId = asset.variantOfId;
    if (!parentId) continue;
    const parent = assetById.get(parentId);
    if (!parent || parent.folderId !== asset.folderId) continue;
    groupedVariantIds.add(asset.id);
    const variants = variantsByParent.get(parentId) ?? [];
    variants.push(asset);
    variantsByParent.set(parentId, variants);
  }

  return assets
    .filter((asset) => !groupedVariantIds.has(asset.id))
    .map((asset) => ({
      asset,
      variants: variantsByParent.get(asset.id) ?? [],
    }));
}

export function getAssetVariants(asset: Asset, assets: Asset[]) {
  return assets.filter(
    (candidate) =>
      candidate.variantOfId === asset.id && candidate.folderId === asset.folderId,
  );
}

export function getAssetVariantParent(asset: Asset, assets: Asset[]) {
  if (!asset.variantOfId) return null;
  const parent = assets.find((candidate) => candidate.id === asset.variantOfId);
  return parent?.folderId === asset.folderId ? parent : null;
}
